import { render } from "./PagesDropdown.vue?vue&type=template&id=afdf259c"
import script from "./PagesDropdown.vue?vue&type=script&lang=js"
export * from "./PagesDropdown.vue?vue&type=script&lang=js"

import exportComponent from "D:\\fclinique\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__